import axios from '@axios'
import axiosRu from '@axios-ru'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchMovies(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get('/movie', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMovie(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createMovie(ctx, payload) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie`, payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMovieDetails(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}?with_staff=1&themes=1`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMovieSequels(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/sequels`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMovieFranchises(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/franchises`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMovieSeasons(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/seasons`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMovieVideos(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/videos`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMovieAwards(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/awards`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    loadMovieKpExtras(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/${id}/load-kp-extras`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    searchFranchises(ctx, {query}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get('/franchise/search', {params: {query}})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchFranchise(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/franchise/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createFranchise(ctx, payload) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post('/franchise', payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateFranchise(ctx, {id, data}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .patch(`/franchise/${id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteFranchise(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .delete(`/franchise/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    attachFranchiseMovie(ctx, {franchiseId, movie_id, part_number}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/franchise/${franchiseId}/movies`, {movie_id, part_number})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateFranchiseMovie(ctx, {franchiseId, movieId, part_number}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .patch(`/franchise/${franchiseId}/movies/${movieId}`, {part_number})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    detachFranchiseMovie(ctx, {franchiseId, movieId}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .delete(`/franchise/${franchiseId}/movies/${movieId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchRatingHistory(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/rating-history`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    loadMovieFromKP(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/import-from-kp/${id}?with_staff=1&themes=1`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    loadMovieFromKPDev(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/import-from-kp/${id}?with_staff=1&themes=1&api=kp-dev`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    loadStaffFromKP(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/load-staff/${id}?with_staff=1&themes=1`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMovieWithStaff(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}?with_staff=1`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchFrames(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/frames`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    toggleFrame(ctx, {movie_id, id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/${movie_id}/frame/${id}/toggle`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    previewFrames(ctx, {id, source}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/frames/preview`, {params: {source}})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    downloadFrames(ctx, {id, frames}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/${id}/frames/download`, {frames})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteFrame(ctx, {movie_id, id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .delete(`/movie/${movie_id}/frame/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMoviesPremiers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get('/movie/premiers', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMoviesTop(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/movie/top', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMoviesFilter(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get('/movie/filter', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    searchMovies(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get('/movie/search', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updatePerson(ctx, {id, data}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/person/${id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
